module.exports = __webpack_public_path__ + "media/images/flags/french-bfcbbbd0a61e1af72da4b560f1779b72.jpg";